import React, { useRef } from 'react'
import { Link, navigate } from 'gatsby'
import { Tabs, TabPanel, Row } from '@paypalcorp/pp-react'
import cln from 'classnames'

import { useSectionInViewContext } from '../../../context/SectionInViewContext'

const navItems = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Set up accounts',
    url: '#link-setupyouraccounttoacceptcardpayments',
  },
  {
    label: 'Generate token',
    url: '#link-generateclienttoken',
  },
  {
    label: 'Render SDK',
    url: '#link-renderjavascriptsdkandpaypalbuttons',
  },
  {
    label: 'Orders API',
    url: '#link-calltheordersapi',
  },
  {
    label: 'Add cards',
    url: '#link-addcardformelements',
  },
  { label: 'Test purchases', url: '#link-testpurchases' },
]

const navItemsSDK = [
  {
    label: 'Add the SDK',
    url: '#link-addthesdk',
  },
  {
    label: 'Configure',
    url: '#link-configureandcustomizeyourintegration',
  },
  {
    label: 'Query parameters',
    url: '#link-queryparameters',
  },
  {
    label: 'Script parameters',
    url: '#link-scriptparameters',
  },
]

const navItemsIos = [
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Integrate with card payments',
    url: '#link-integratecardpayments',
  },
  {
    label: 'Integrate with PayPal Wallet',
    url: '#link-integratepaypalwallet',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps and customizations',
    url: '#link-nextstepsandcustomizations',
  },
]

const navItemsApple = [
  {
    label: 'Overview',
    url: '#link-applepayintegration',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Setup',
    url: '#link-setupyoursandboxaccounttoacceptapplepay',
  },
  {
    label: 'Getting started',
    url: '#link-gettingstartedinyourtestingenvironment',
  },
  {
    label: 'Integrate ApplePay',
    url: '#link-integrateapplepaycheckout',
  },
  {
    label: 'Button setup',
    url: '#link-setupyourapplepaybutton',
  },
  {
    label: 'Create session',
    url: '#link-createapplepaysession',
  },
  {
    label: 'Payment sheet',
    url: '#link-showthepaymentsheet',
  },
  {
    label: 'Test',
    url: '#link-testyourintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps',
    url: '#link-nextstepscustomizations',
  },
]

export default function NavigationTabs({
  pageName,
  buttonSizes = 'normal',
}: any) {
  const { visibleSection, setVisibleSection } = useSectionInViewContext()
  let dataSet: any

  if (pageName === 'ios') {
    dataSet = navItemsIos
  } else if (pageName === 'applePay') {
    dataSet = navItemsApple
  } else if (pageName === 'sdk') {
    dataSet = navItemsSDK
  } else {
    dataSet = navItems
  }

  // const dataSet = pageName === 'ios' ? navItemsIos : navItems
  const selectedIndex = dataSet.findIndex((item) => item.url === visibleSection)

  return (
    <div className="navigationWrapper">
      <Tabs
        name="TabsGroup1"
        className={`navTabs-ppui ${
          buttonSizes === 'large' ? 'largeButtons' : ''
        }`}
        selectedTabIdx={selectedIndex}
        tabs={dataSet.map((item) => ({
          label: item.label,
          id: item.url,
          panelId: item.url,
        }))}
        onClick={(e, index) => {
          setVisibleSection(dataSet[index].url)
          navigate(dataSet[index].url)
        }}
      >
        {dataSet.map((item) => (
          <TabPanel key={item.url} id={item.url} tabId={item.url} />
        ))}
      </Tabs>
    </div>
  )
}
